import * as o from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/Clock.es.js";
const c = o.forwardRef((e, r) => /* @__PURE__ */ o.createElement(t, { ref: r, ...e, weights: a }));
c.displayName = "ClockIcon";
const n = c;
export {
  n as Clock,
  c as ClockIcon
};
